import { free_plugin } from "./free";
import { register_plugin } from "./payment-plugin-registry";
// import { korapay_plugin } from "./korapay";
import { paytiko_plugin } from "./paytiko";
// import { nowpayments_plugin } from "./nowpayments";

// register_plugin(korapay_plugin);
register_plugin(free_plugin);
register_plugin(paytiko_plugin);
// register_plugin(nowpayments_plugin);
